// Mirrors LinkType.LINK_TYPE_HYPERLINK / _PAGE. Declared here rather than
// imported: LinkType reaches VCL's barrel, which cannot load outside webpack.
const STORED_HYPERLINK = "hyperlink";
const STORED_PAGE = "page";

export const UI_LINK_TYPE_URL = "url";
export const UI_LINK_TYPE_PAGE = "page";

export const UI_LINK_TYPE_OPTIONS = [
  { id: UI_LINK_TYPE_URL, name: "URL" },
  { id: UI_LINK_TYPE_PAGE, name: "Page" },
];

// A page is dynamic when it declares a uri-sourced context — its slug carries
// {uri vars} the author must source. Drives whether the uri-var modal is offered.
export function isDynamicPage(pageItem) {
  return (pageItem?.requiredContexts?.length ?? 0) > 0;
}

export function storedLinkTypeFor(uiLinkType) {
  return uiLinkType === UI_LINK_TYPE_URL ? STORED_HYPERLINK : STORED_PAGE;
}

// Legacy `story` / `hashtag` values are page navigations too — the read-time
// migrations rewrite them to `page`, so anything not hyperlink is a page here.
export function uiLinkTypeFor(linkType) {
  return linkType === STORED_HYPERLINK ? UI_LINK_TYPE_URL : UI_LINK_TYPE_PAGE;
}

// One "Page" list now — static and dynamic pages share the picker; the uri-var
// modal handles sourcing for the dynamic ones.
export function pagesForUiLinkType(pageItems, uiLinkType) {
  return uiLinkType === UI_LINK_TYPE_PAGE ? pageItems ?? [] : [];
}

// Entity types may carry a dotted app prefix ("CreatorStudio.Story"); the
// navigation resolver strips it, so matching here has to strip it too.
const bareEntityType = type => String(type ?? "").split(".").at(-1);

export function contextCandidatesForPage(pageItem, contextCandidates) {
  const wanted = new Set((pageItem?.requiredContexts ?? []).map(required => bareEntityType(required.entityType)));
  return (contextCandidates ?? []).filter(candidate => wanted.has(bareEntityType(candidate.entityType)));
}

export function unavailableReasonForPage(pageItem, contextCandidates, hiddenReasonFor = null) {
  const hiddenReason = hiddenReasonFor ? hiddenReasonFor(pageItem?.value ?? pageItem?.id) : "";
  if (hiddenReason) {
    return hiddenReason;
  }
  if (!isDynamicPage(pageItem)) {
    return null;
  }
  if (contextCandidatesForPage(pageItem, contextCandidates).length) {
    return null;
  }
  const types = [...new Set(pageItem.requiredContexts.map(required => bareEntityType(required.entityType)))];
  return `no ${types.join(", ")} in context`;
}

// Never disabled: a page's uri vars can ALWAYS be met by a constant, so every
// page is a valid target. Missing context is post-selection guidance, not a block.
export function decoratePagesForPicker(pageItems) {
  return (pageItems ?? []).map(pageItem => ({ ...pageItem, disabled: false, disabledReason: "" }));
}

export function nextUiLinkType(linkType) {
  return uiLinkTypeFor(linkType);
}
